import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'
import Bold from '@/components/Bold'
import Splash from '@/components/Splash'
import Home from '@/components/Home'
import GuestType from '@/components/GuestType'
import CandidateType from '@/components/CandidateType'
import CandidatePosition from '@/components/CandidatePosition'
import FormCandidate from '@/components/FormCandidate'
import Thanks from '@/components/Thanks'
import Overview from '@/components/client/Overview'
import BusinessStage from '@/components/client/BusinessStage'
import Cart from '@/components/client/Cart'
import FormClient from '@/components/client/FormClient'
import Error404 from '@/components/Error404'
import ContactForm from '@/components/ContactForm'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: App,
      template: '<router-view class="child-view"></router-view>',
      children:[
        {
          path: '/home',
          name: 'Home',
          component: Home
        },
        {
          path: '/',
          name: 'Splash',
          component: Splash
        },
        {
          path: '/guest',
          name: 'GuestType',
          component: GuestType
        },
        {
          path: '/candidate',
          name: 'CandidateType',
          component: CandidateType,
        },
        {
          path: '/candidate/position',
          name: 'CandidatePosition',
          component: CandidatePosition,
        },
        {
          path: '/candidate/contact',
          name: 'FormCandidate',
          component: FormCandidate,
        },
        {
          path: '/thanks',
          name: 'Thanks',
          component: Thanks,
        },
        {
          path: '/client/overview',
          name: 'Overview',
          component: Overview,
        },
        {
          path: '/client/stage',
          name: 'BusinessStage',
          component: BusinessStage,
        },
        {
          path: '/client/cart',
          name: 'Cart',
          component: Cart,
        },
        {
          path: '/client/contact',
          name: 'FormClient',
          component: FormClient,
        },
        {
          path: '/contact',
          name: 'ContactForm',
          component: ContactForm,
        },
        {
          path: '/404',
          name: 'Error404',
          component: Error404,
        },
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js